import BaseAPI from './base.api';

export interface GeoJSONPolygon {
  type: 'Polygon';
  coordinates: number[][][];
}

export interface ImportedLocation {
  locationId: string;
  customerId: string;
  name: string;
  locationType: 'loading' | 'dumping' | string;
  active: boolean;
  centroidLat: number | null;
  centroidLon: number | null;
  status: string;
  minutes: number | null;
  trucksCapacity: number | null;
  easting: number;
  northing: number;
  elevation: number;
  meta: Record<string, unknown>;
  geohashes: string[];
  zoneGeog: GeoJSONPolygon | null;
  createdAt: string;
  updatedAt: string;
}

export interface BulkCreateLocationsResult {
  message: string;
  created: number;
  failed: number;
  failedLocations: Array<Record<string, unknown> & { reason: string }>;
}

export default class LocationImporterAPI extends BaseAPI {
  getLocations = async (): Promise<ImportedLocation[]> => {
    const response = await this.API.get('location-importer', {
      params: { customerId: this.customerId },
    });
    return response.data;
  };

  updateLocation = async (
    locationId: string,
    patch: Record<string, unknown>
  ): Promise<void> => {
    await this.API.put(`location-importer/${locationId}`, patch);
  };

  deleteLocation = async (
    locationId: string,
    softDelete = true
  ): Promise<void> => {
    await this.API.delete(`location-importer/${locationId}`, {
      params: softDelete ? { softDelete: true } : undefined,
    });
  };

  createLocations = async (
    locations: Array<Record<string, unknown>>
  ): Promise<BulkCreateLocationsResult> => {
    const response = await this.API.post('location-importer/bulk', {
      locations: locations.map((loc) => ({
        ...loc,
        customerId: this.customerId,
      })),
    });
    return response.data;
  };

  getDeletedLocations = async (): Promise<ImportedLocation[]> => {
    const response = await this.API.get('location-importer/deleted', {
      params: { customerId: this.customerId },
    });
    return response.data;
  };

  restoreLocations = async (locationIds: string[]): Promise<void> => {
    await this.API.patch('location-importer/bulk/restore', { locationIds });
  };
}
